<template>
    <section class="products">
        <div class="product" v-for="(product, index) in cartData.products" :key="index">
            <Product :product="product" :index="index" />
        </div>
    </section>
</template>
<script>
import { mapGetters } from "vuex";
import Product from "./Product.vue";

export default {
    components: {
        Product
    },
    computed: {
        ...mapGetters({
            cartData: "cart/getCartData",
        }),
    },
    setup(props) {
        return {}
    },
}
</script>
